import {Accordion} from 'react-bootstrap';


function Skills() {

  return (
    <Accordion>
        <Accordion.Item eventKey="a">
            <Accordion.Header>
                <h4>WEB DEVELOPMENT</h4>
            </Accordion.Header>
            <Accordion.Body>
                <ul>
                    <li>PHP</li>                                        
                    <li>CakePHP</li>
                    <li>CodeIgniter</li>
                    <li>Laravel</li>
                    <li>Kohana</li>
                    <li>HTML/CSS/Javascript</li>
                    <li>C#.NET</li>
                    <li>React.js</li>
                    <li>MERN Stack</li>
                    <li>Python</li>
                    <li>Django</li>            
                    <li>Wordpress/Elemenor</li>
                    <li>Wordpress API</li>
                    <li>Gravity Forms</li>
                    <li>Yoast SEO</li>
                    <li>Google Firebase/Console</li>
                </ul>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="b">
            <Accordion.Header>
                <h4>AUTOMATION</h4>
            </Accordion.Header>
            <Accordion.Body>
                <ul>
                    <li>Active Campaign</li>                    
                    <li>Zapier</li>              
                    <li>Albato</li>              
                    <li>DiaFlow</li>              
                    <li>GHL</li>              
                    <li>n8n</li>              
                </ul>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="c">
            <Accordion.Header>
                <h4>DESIGNER TOOLS</h4>
            </Accordion.Header>
            <Accordion.Body>
                <ul>
                    <li>Figma</li>                    
                    <li>Adobe XD</li>              
                    <li>Canva</li>              
                </ul>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="d">
            <Accordion.Header>
                <h4>WEB TOOLS</h4>
            </Accordion.Header>
            <Accordion.Body>
                <ul>
                    <li>Poe.com</li>                    
                    <li>Page Speed Insight</li>              
                    <li>Semrush</li>              
                    <li>Meta/Pixel</li>              
                    <li>Google Analytics/GTM</li>              
                    <li>WAVE - Web Accessibility Evaluation Tools</li>              
                </ul>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="e">
            <Accordion.Header>
                <h4>VERSION CONTROL TOOLS</h4>
            </Accordion.Header>
            <Accordion.Body>
                <ul>
                    <li>SVN</li>
                    <li>MERCURIAL</li>
                    <li>GIT</li>
                    <li>Team Foundation VC</li>
                    <li>Bitbucket</li>
                    <li>Github</li>
                </ul>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
            <Accordion.Header>
                <h4>WINDOWS APP DEVELOPMENT</h4>
            </Accordion.Header>
            <Accordion.Body>
                <ul>
                    <li>DELPHI</li>
                    <li>C#.NET WINFORM/WPF</li>
                    <li>VISUAL BASIC</li>
                    <li>C++</li>
                    <li>PASCAL</li>
                    <li>Python</li>
                </ul>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
            <Accordion.Header>
                <h4>DATABASE</h4>
            </Accordion.Header>
            <Accordion.Body>
                <ul>
                    <li>MYSQL/MARIA DB</li>
                    <li>MS SQL</li>
                    <li>Oracle</li>
                    <li>Sybase</li>
                    <li>FLATFILE DB (DBF, Base64)</li>
                    <li>MS ACCESS</li>
                    <li>MongoDB</li>
                    <li>Firebase</li>
                </ul>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
            <Accordion.Header>
                <h4>SERVERS</h4>
            </Accordion.Header>
            <Accordion.Body>
                <ul>
                    <li>LINUX Server</li>
                    <li>XAMPP/WAMP</li>
                    <li>IIS Windows</li>
                    <li>CPANEL/WHM</li>
                    <li>Namecheap</li>
                </ul>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="4">
            <Accordion.Header>
                <h4>MOBILE APP DEVELOPMENT</h4>
            </Accordion.Header>
            <Accordion.Body>
                <ul>
                    <li>ANDROID STUDIO</li>
                    <li>VISUAL STUDIO USING C# .NET</li>
                </ul>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="5">
            <Accordion.Header>
                <h4>VIDEO EDITING</h4>
            </Accordion.Header>
            <Accordion.Body>
                <ul>
                    <li>ADOBE Premiere Pro</li>
                    <li>ADOBE After Effects</li>
                    <li>CapCut</li>
                </ul>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="6">
            <Accordion.Header>
                <h4>PHOTO AND VECTOR EDITING TOOLS</h4>
            </Accordion.Header>
            <Accordion.Body>
                <ul>
                    <li>ADOBE Photoshop</li>
                    <li>ADOBE Illustrator</li>
                    <li>Canva</li>
                </ul>
            </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="7">
            <Accordion.Header>
                <h4>LIVE STREAMING</h4>
            </Accordion.Header>
            <Accordion.Body>
                <ul>
                    <li>Open Broadcaster Software OBS</li>
                    <li>ProPresenter 7</li>
                </ul>
            </Accordion.Body>
        </Accordion.Item>
        
        <Accordion.Item eventKey="8">
            <Accordion.Header>
                <h4>OTHERS</h4>
            </Accordion.Header>
            <Accordion.Body>
                <ul>                    
                    <li>MS Office</li>
                    <li>Google Sheets, Docs, Slides</li>
                    <li>Propresenter 7</li>
                    <li>Easyworship 7</li>
                    <li>ADOBE Audition</li>
                    <li>Presonus StudioOne</li>
                    <li>Ableton</li>
                    <li>Clockify</li>
                    <li>ClickUp</li>
                    <li>JIRA</li>
                    <li>TRELLO</li>
                    <li>Trackabi</li>
                    <li>Asana</li>
                    <li>Orangescrum</li>
                    <li>ZOOM</li>
                    <li>Teams</li>
                    <li>Slack</li>
                    <li>WhatsApp</li>
                    <li>Line</li>
                </ul>
            </Accordion.Body>
        </Accordion.Item>
    </Accordion>
  );
}

export default Skills;